import { DialogContent, styled } from '@mui/material';
export var StyledDialogContent = styled(DialogContent, {
    shouldForwardProp: function (prop) { return ![''].includes(String(prop)); },
})(function () { return ({}); });
//# sourceMappingURL=styled.js.map